import React, { PureComponent } from 'react'
import { PAGE_PREFIX } from '../utils/config.js'
import {
  displayToast,
  getCushionItemData,
  getHasZipperOrientation,
  sendGtag,
  slugify,
} from '../utils/utils.js'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { connect } from 'react-redux'
import {
  addToCart,
  deleteItemFromCart,
  setCanProceedToNextStep,
  setIsConnected,
  setScrollToFunction,
  setSelectedType,
} from '../actions/generalActions.js'
import { setCurrentFlow, toggleTypesStepView } from '../actions/layoutActions.js'
import Stepper from './Stepper/Stepper.jsx'

class CushionDesignerSteps extends PureComponent {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    if (location.pathname.includes('-join') || location.pathname.includes('-pinch')) {
      const { dispatch } = this.props
      dispatch(setIsConnected(true))
    }
  }

  componentDidUpdate() {
    if (! location.search.includes('fabric_next')) {
      return
    }

    const { nextStepURL } = this._getStepperVars()

    this.handleNextStepClick(nextStepURL)()
  }

  handleNextStepClick = (nextStepURL) => () => {
    const { steps, currentLocationIndex, history, } = this.props
    this._changeScrollToFunction(true)()
    history.push(nextStepURL)

    switch (steps[currentLocationIndex - 2]) {
      case 'Select Type':
        sendGtag('next_button_type')
        break
      case 'Set':
        sendGtag('next_button_set')
        break
      case 'Shape':
        sendGtag('next_button_shape')
        break
      case 'Dimensions':
        sendGtag('next_button_dimensions')
        break
      case 'Fabric':
        sendGtag('next_button_fabrics')
        break
      case 'Style':
        sendGtag('next_button_style')
        break
      case 'Fasteners':
        sendGtag('next_button_fasteners')
        break
      default:
        break
    }
  }

  handlePreviousClick = (splitPathName, preventUserFromChangingTypeIfEdit) => (index) => () => {
    const { history } = this.props

    if (preventUserFromChangingTypeIfEdit) {
      this._openPopUp()
    } else {
      this._changeScrollToFunction(false)()
    }

    const prevIndexURL = index + 3
    const prevStepURL = PAGE_PREFIX + splitPathName.slice(0, prevIndexURL).join('/')
    history.push(prevStepURL)
  }

  _addToCart = () => {
    const { general, dispatch, history, params } = this.props
    const { type, removeItem, productQty } = general

    const cushionItemData = getCushionItemData(general, history, params)
    let cartKey = localStorage.getItem('cartKey')

    if (removeItem?.removeitem) {
      dispatch({ type: 'ADD_TO_CART' })
      deleteItemFromCart(removeItem.removeitem, removeItem._wpnonce).then((res) => {
        if (res) {
          setTimeout(() => {
            dispatch(addToCart(cartKey, type, cushionItemData, false, productQty))
          }, 100)
        }
      })
    } else {
      setTimeout(() => {
        dispatch(addToCart(cartKey, type, cushionItemData, false, productQty))
      }, 100)
    }
  }

  _renderSteps = (nextStepURL, splitPathName, preventUserFromChangingTypeIfEdit) => {
    const { steps, currentLocationIndex, general, params } = this.props
    const { canProceedToNextStep, totalPrice, addingToCart } = general
    const price = !totalPrice?.totalPrice
      ? 'xxx.xx'
      : parseFloat(Math.round(totalPrice?.totalPrice * 100) / 100)
          .toFixed(2)
          .toString()

    let stepperSteps = steps.map((title, index) => ({
      title: title,
      stepName: title.toLowerCase(),
      stepIndex: index,
    }))

    if (params?.type?.id === 'type') {
      stepperSteps = stepperSteps.slice(0, 1)
    }

    return (
      <Stepper
        stepperIndex={currentLocationIndex - 2}
        steps={stepperSteps}
        canProceedToNextStep={canProceedToNextStep}
        handleNextStepClick={this.handleNextStepClick(nextStepURL)}
        handlePreviousClick={this.handlePreviousClick(
          splitPathName,
          preventUserFromChangingTypeIfEdit,
        )}
        price={price}
        addToCart={this._addToCart}
        addingToCart={addingToCart}
      />
    )
  }

  _addToCart = () => {
    const { general, dispatch, history, params } = this.props
    const { type, removeItem, productQty, totalPrice } = general
    const cushionItemData = getCushionItemData(general, history, params)
    const price = !totalPrice?.totalPrice ? 0 : Math.round(totalPrice?.totalPrice * 100) / 100

    sendGtag('add_to_cart_cd', type?.name)

    sendGtag('add_to_cart', null, {
      currency: 'USD',
      value: price,
      items: [
        {
          item_id: `#${type?.id.toString()}`,
          item_name: type?.name,
          item_variant: cushionItemData?.fabric?.fabric_name ? cushionItemData?.fabric?.fabric_name : 'Customer Fabric',
        },
      ],
    })

    let cartKey = localStorage.getItem('cartKey')
    if (removeItem?.removeitem) {
      deleteItemFromCart(removeItem.removeitem, removeItem._wpnonce).then((res) => {
        if (res) {
          dispatch(addToCart(cartKey, type, cushionItemData, false, productQty))
        }
      })
    } else {
      dispatch(addToCart(cartKey, type, cushionItemData, false, productQty))
    }
  }

  _toggleDeepSeatingView = () => {
    const { dispatch } = this.props

    dispatch(setCurrentFlow('default'))
    dispatch(setSelectedType(null))
    dispatch(setCanProceedToNextStep(false))
    dispatch(toggleTypesStepView())
  }

  _changeScrollToFunction = (enableScrollTo) => () => {
    const { dispatch } = this.props
    dispatch(setScrollToFunction(enableScrollTo))
  }

  _openPopUp = () => {
    displayToast('You can`t change the type of the cushion when you edit ', 'error')
  }

  _getStepperVars = () => {
    const { params, location, currentLocationIndex, general, cushion, urls, layout } = this.props
    const {
      dimensions,
      fastenerPlacement,
      additionalShape,
      shape,
      fasteners,
      style,
      category,
      individualRoundedBack,
      individualRoundedSeat,
      type,
      removeItem,
      noOfFasteners,
      zipperOrientation,
    } = general
    const { typesStepView } = layout
    const { cushionDimensions } = cushion

    if (location.pathname !== '/' && currentLocationIndex !== 1) {
      const nextStep = urls[currentLocationIndex - 1]
      const currStep = urls[currentLocationIndex - 2]
      let splitPathName = location.pathname.split('/')
      const prevStepURL = PAGE_PREFIX + [...splitPathName].slice(0, -1).join('/')
      let currentParam = currStep?.replace('/', '')
      const hasZipperOrientation = getHasZipperOrientation(general)

      if (general[currentParam]?.id) {
        splitPathName[splitPathName.length - 1] =
          `${general[currentParam].id}-${slugify(general[currentParam].name)}`
        if (currentParam === 'fasteners') {
          if (params?.type?.id === '11741') {
            splitPathName[splitPathName.length - 1] =
              `${general[currentParam].id}-${slugify(fasteners.name)}${fasteners.name !== 'None' ? `-${noOfFasteners}` : ''}`
          } else {
            splitPathName[splitPathName.length - 1] =
              `${general[currentParam].id}-${slugify(fasteners.name)}${fasteners.name !== 'None' ? `-${fastenerPlacement.checkboxes.join('')}-${fastenerPlacement.mirroredCheckboxes.join('')}` : ''}`
          }
        }
        if (currentParam === 'type') {
          splitPathName[splitPathName.length - 1] =
            `${general[currentParam].id}-${slugify(general[currentParam].name)}${typesStepView !== 'allTypes' ? '-custom' : ''}`
        }
        if (currentParam === 'shape') {
          splitPathName[splitPathName.length - 1] =
            `${general[currentParam].id}-${slugify(shape.name)}${individualRoundedBack ? '-individually-rounded' : ''}${additionalShape ? `-${additionalShape.id}-${slugify(additionalShape.name)}${individualRoundedSeat ? '-individually-rounded' : ''}` : ''}`
        }
        if (currentParam === 'fabric') {
          splitPathName[splitPathName.length - 1] =
            `${general[currentParam].id}${general.fabricDirection ? `-${general.fabricDirection}` : '-nondirectional'}-${general.fabric.name.split(' ').join('-').toLowerCase()}`
        }
        if (currentParam === 'style') {
          splitPathName[splitPathName.length - 1] = general.cordFabric
            ? `${general[currentParam].id}-${general.cordFabric?.id}${general.cordFabricDirection ? `-${general.cordFabricDirection}` : '-nondirectional'}-${general.cordFabric?.name.split(' ').join('-').toLowerCase()}`
            : `${general[currentParam].id}-${style.slug}`
        }
      }

      if (currentParam === 'dimensions' && dimensions && cushionDimensions) {
        let urlDimensions = ''
        const cushionDimensionsKeyArray = Object.keys(cushionDimensions)

        cushionDimensionsKeyArray.forEach((dimension) => {
          urlDimensions += `${dimensions[dimension]}-`
        })

        if (dimensions.jointing) {
          urlDimensions += dimensions.jointing
        } else {
          urlDimensions = urlDimensions.slice(0, -1)
        }

        if (hasZipperOrientation) {
          urlDimensions += `-${zipperOrientation}`
        }

        splitPathName[splitPathName.length - 1] = urlDimensions
      }

      if (currentParam === 'type') {
        splitPathName[1] = category ? `${category}` : 'category'
      }

      const replacedPathName = splitPathName.join('/')
      let nextStepURL = nextStep
        ? PAGE_PREFIX + replacedPathName + nextStep
        : PAGE_PREFIX + location.pathname

      if (currentParam === 'type') {
        nextStepURL = nextStepURL.replace('category', category)
      }

      let prevStepURLPrvented = `/cd/${category}/${type?.id}-${type?.slug}`
      let preventUserFromChangingTypeIfEdit =
        prevStepURL === prevStepURLPrvented && removeItem?.removeitem

      return {
        nextStepURL,
        splitPathName,
        preventUserFromChangingTypeIfEdit,
      }
    }

    return null
  }

  render() {
    const vars = this._getStepperVars()

    if (! vars) {
      return null
    }

    const { nextStepURL, splitPathName, preventUserFromChangingTypeIfEdit } = vars

    return this._renderSteps(nextStepURL, splitPathName, preventUserFromChangingTypeIfEdit)
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  cushion: state.cushion,
  layout: state.layout,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionDesignerSteps))
